<template>
    <div>
        <div v-if="reportLoading">
            <div class="row">
                <div class="col-md-12 text-center pt-5 pb-5 mt-5 pb-5">
                    <i class="fa fa-circle-notch fa-spin fa-10x fa-fw" aria-hidden="true"></i>
                </div>
            </div>
        </div>

    <div v-if="reportFound === false && reportLoading === false">
        <div class="row pb-4">
            <div class="col-md-8">
                <h2 class="page-header-title">Sorry...</h2>
            </div>
        </div>
        <div class="widget">
            <div class="widget-body">
                <p>The report could not be found. Please check the URL and try again.</p>
                <p> <router-link to="/">Return Home</router-link></p>
            </div>
        </div>
    </div>
    <div v-if="report">
        <div class="row pb-4">
            <div class="col-md-8">
                <h2 class="page-header-title">
                    <router-link to="/door-maintenance-reports">
                        Door Maintenance Reports</router-link>
                    &raquo;
                    {{ report.job_number }} | {{ report.prepared_for }}        </h2>
            </div>
            <div class="col-md-4">
                <router-link :to="{ name: 'door-maintenance-report-edit', params: {id: report.site_door_maintenance_report_id} }" class="btn btn-outline-secondary btn-square btn-lg pull-right">
                    Edit Report
                </router-link>
            </div>
        </div>

        <div class="widget">
            <div class="widget-body">
                <table class="table table-bordered">
                    <tbody>
                        <tr v-if="report.use_bm_trada_template">
                            <td><strong>Sequential Reference Number</strong></td>
                            <td>{{ report.sequential_reference_number }}</td>
                        </tr>
                        <tr>
                            <td><strong>Maintenance Job Reference</strong></td>
                            <td>{{ report.job_number }}</td>
                        </tr>
                        <tr>
                            <td><strong>Prepared for</strong></td>
                            <td>{{ report.prepared_for }}</td>
                        </tr>
                        <tr>
                            <td><strong>Site Address</strong></td>
                            <td>{{ report.site_address }}</td>
                        </tr>
                        <tr>
                            <td><strong>Date of Issue</strong></td>
                            <td>{{ report.date_of_issue | formatDate }}</td>
                        </tr>
                        <tr>
                            <td><strong>Is this being carried out under BM Trada?</strong></td>
                            <td>{{ report.use_bm_trada_template ? 'Yes' : 'No'  }}</td> 
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="widget has-shadow">
                    <div class="widget-header bordered no-actions d-flex align-items-center">
                        <h3>Doors</h3>
                    </div>
                    <div class="widget-body">
                        <div class="row pb-3">
                            <div class="col-md-12 mt-3">
                                <table class="table table-condensed table-bordered" v-if="doors && doors.length > 0">
                                    <door-maintenance-report-item-line
                                            v-for="item in doors"
                                            v-bind:key="item.site_door_maintenance_report_item_id"
                                            v-bind:door="item"
                                    ></door-maintenance-report-item-line>
                                </table>
                                <p class="text-center" v-else>There are no issues attached to this report.</p>
                            </div>
                        </div>
                        <router-link :to="{ name: 'door-maintenance-report-add-item', params: {id: report.site_door_maintenance_report_id} }" class="btn btn-outline-primary btn-square pt-3 pb-3 mt-3 mb-3" style="display:block;width:100%">
                            Add Door Set
                        </router-link>

                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import DoorMaintenanceReportItemLine from '@/components/DoorMaintenanceReportItemLine.vue';

    export default {
        components: {
            DoorMaintenanceReportItemLine,
        },
        data() {
            return {
                reportFound: false,
                reportLoading: true,
                report: null,
                doors: [],
            }
        },
        methods: {
            getReport() {
                var vmt = this;
                this.getDb(function onConnected(db) {

                    var vm = vmt;
                    try {
                        var reportId = parseInt(vm.$route.params.id);
                        var objectStore = db.transaction('door_maintenance_reports').objectStore('door_maintenance_reports');
                        var storeRequest = objectStore.get(reportId);


                        storeRequest.onsuccess = function(event) {
                            vm.report = storeRequest.result;
                            if (storeRequest.result !== undefined) {
                                vm.reportFound = true;
                            }
                            vm.reportLoading = false;
                        };
                        storeRequest.onerror = function(e) {
                            vm.reportFound = false;
                            vm.reportLoading = false;
                        }
                    } catch (e) {
                        console.log(e);
                    }
                })
            },
            getReportItems() {
                var vm = this;
                this.getDb(function onConnected(db) {
                    vm.doors = [];
                    
                    try {
                        var reportId = parseInt(vm.$route.params.id);
                        var objectStore = db.transaction('door_maintenance_report_items').objectStore('door_maintenance_report_items');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (
                                        vm.doors && reportId == cursor.value.site_door_maintenance_report_id
                                        && (cursor.value.is_deleted === false || cursor.value.is_deleted === undefined)
                                    ) {
                                        vm.doors.push(cursor.value);
                                    }
                                    cursor.continue();
                                }
                            }
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            }
        },
        mounted () {
            const modulesData = this.$session.get('enabled_modules');
            if(!modulesData || modulesData.indexOf('FDIR') === -1) {
                this.$router.push('/');
                return;
            }
            
            this.getReport();
            this.getReportItems();
        }
    }
</script>